<template>
    <processInspectionCommon></processInspectionCommon>
</template>
<script>
import processInspectionCommon from './processInspectionCommon.vue';

export default {
    name: 'processInspectionEdit',
    components: {
        processInspectionCommon,
    },
};

</script>
